export default "__VITE_ASSET__f570e214__"